import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    environment: z.enum(['production', 'staging', 'test', 'development']),
    checks: z.object({
        database: z.object({ ok: z.boolean(), latencyMs: z.number() }),
        jobs: z.object({ ok: z.boolean(), oldestPendingSeconds: z.number().nullable() }),
        worker: z.object({ ok: z.boolean(), lastHeartbeatAt: z.string().nullable() }),
        backup: z.object({ ok: z.boolean(), lastBackupAt: z.string().nullable() }),
        disk: z.object({ ok: z.boolean(), freePercent: z.number().nullable() }),
    }),
    errorsSinceStart: z.number(),
});
//# sourceMappingURL=health.js.map